import type { ChecklistFieldValue, ChecklistItem } from "@smartsuite/types";

/**
 * Normalizes a stored checklist default into a full `ChecklistFieldValue` for the Formik
 * initial value. Tolerates both a bare `ChecklistItem[]` and an already-shaped
 * `ChecklistFieldValue`. Empty / null / no items → `undefined` (no default applied), so
 * `getFormDefaultValues` skips seeding — matching the other field normalizers.
 */
export const normalizeChecklistDefaultValue = (value: unknown): ChecklistFieldValue | undefined => {
  const items: ChecklistItem[] | undefined = Array.isArray(value)
    ? (value as ChecklistItem[])
    : (value as ChecklistFieldValue | undefined)?.items;

  if (!items?.length) return undefined;

  return {
    items,
    total_items: items.length,
    completed_items: items.filter((item) => item.completed).length,
  };
};
